import { render, staticRenderFns } from "./UserPanel.vue?vue&type=template&id=306ce396&scoped=true"
import script from "./UserPanel.vue?vue&type=script&lang=js"
export * from "./UserPanel.vue?vue&type=script&lang=js"
import style0 from "./UserPanel.vue?vue&type=style&index=0&id=306ce396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306ce396",
  null
  
)

export default component.exports